if (document.querySelectorAll('svg use').length) {
	import('svg4everybody').then(({ default: svg4everybody }) => {
		svg4everybody();
	});
}

/* eslint-disable */

// source:https://github.com/Financial-Times/polyfill-service/blob/master/polyfills/_DOMTokenList/polyfill.js
/*
Copyright (c) 2016, John Gardner
Permission to use, copy, modify, and/or distribute this software for any purpose with or without fee is hereby granted, provided that the above copyright notice and this permission notice appear in all copies.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/
var _DOMTokenList = (function() {
	// eslint-disable-line no-unused-vars
	var dpSupport = true;
	var defineGetter = function defineGetter(object, name, fn, configurable) {
		if (Object.defineProperty)
			Object.defineProperty(object, name, {
				configurable: false === dpSupport ? true : !!configurable,
				get: fn
			});
		else object.__defineGetter__(name, fn);
	};

	/** Ensure the browser allows Object.defineProperty to be used on native JavaScript objects. */
	try {
		defineGetter({}, 'support');
	} catch (e) {
		dpSupport = false;
	}

	var _DOMTokenList = function _DOMTokenList(el, prop) {
		var that = this;
		var tokens = [];
		var tokenMap = {};
		var length = 0;
		var maxLength = 0;
		var addIndexGetter = function addIndexGetter(i) {
			defineGetter(
				that,
				i,
				function() {
					preop();
					return tokens[i];
				},
				false
			);
		};
		var reindex = function reindex() {
			/** Define getter functions for array-like access to the tokenList's contents. */
			if (length >= maxLength)
				for (; maxLength < length; ++maxLength) {
					addIndexGetter(maxLength);
				}
		};

		/** Helper function called at the start of each class method. Internal use only. */
		var preop = function preop() {
			var error;
			var i;
			var args = arguments;
			var rSpace = /\s+/;

			/** Validate the token/s passed to an instance method, if any. */
			if (args.length)
				for (i = 0; i < args.length; ++i) {
					if (rSpace.test(args[i])) {
						error = new SyntaxError(
							'String "' + args[i] + '" ' + 'contains' + ' an invalid character'
						);
						error.code = 5;
						error.name = 'InvalidCharacterError';
						throw error;
					}
				} /** Split the new value apart by whitespace*/
			if (typeof el[prop] === 'object') {
				tokens = ('' + el[prop].baseVal).replace(/^\s+|\s+$/g, '').split(rSpace);
			} else {
				tokens = ('' + el[prop]).replace(/^\s+|\s+$/g, '').split(rSpace);
			}

			/** Avoid treating blank strings as single-item token lists */
			if ('' === tokens[0]) tokens = [];

			/** Repopulate the internal token lists */
			tokenMap = {};
			for (i = 0; i < tokens.length; ++i) {
				tokenMap[tokens[i]] = true;
			}
			length = tokens.length;
			reindex();
		};

		/** Populate our internal token list if the targeted attribute of the subject element isn't empty. */
		preop();

		/** Return the number of tokens in the underlying string. Read-only. */
		defineGetter(that, 'length', function() {
			preop();
			return length;
		});

		/** Override the default toString/toLocaleString methods to return a space-delimited list of tokens when typecast. */
		that.toLocaleString = that.toString = function() {
			preop();
			return tokens.join(' ');
		};

		that.item = function(idx) {
			preop();
			return tokens[idx];
		};

		that.contains = function(token) {
			preop();
			return !!tokenMap[token];
		};

		that.add = function() {
			preop.apply(that, (args = arguments));

			for (var args, token, i = 0, l = args.length; i < l; ++i) {
				token = args[i];
				if (!tokenMap[token]) {
					tokens.push(token);
					tokenMap[token] = true;
				}
			}

			/** Update the targeted attribute of the attached element if the token list's changed. */
			if (length !== tokens.length) {
				length = tokens.length >>> 0;
				if (typeof el[prop] === 'object') {
					el[prop].baseVal = tokens.join(' ');
				} else {
					el[prop] = tokens.join(' ');
				}
				reindex();
			}
		};

		that.remove = function() {
			preop.apply(that, (args = arguments));

			/** Build a hash of token names to compare against when recollecting our token list. */
			for (var args, ignore = {}, i = 0, t = []; i < args.length; ++i) {
				ignore[args[i]] = true;
				delete tokenMap[args[i]];
			}

			/** Run through our tokens list and reassign only those that aren't defined in the hash declared above. */
			for (i = 0; i < tokens.length; ++i) {
				if (!ignore[tokens[i]]) t.push(tokens[i]);
			}
			tokens = t;
			length = t.length >>> 0;

			/** Update the targeted attribute of the attached element. */
			if (typeof el[prop] === 'object') {
				el[prop].baseVal = tokens.join(' ');
			} else {
				el[prop] = tokens.join(' ');
			}
			reindex();
		};

		that.toggle = function(token, force) {
			preop.apply(that, [token]);

			/** Token state's being forced. */
			if (undefined !== force) {
				if (force) {
					that.add(token);
					return true;
				} else {
					that.remove(token);
					return false;
				}
			}

			/** Token already exists in tokenList. Remove it, and return FALSE. */
			if (tokenMap[token]) {
				that.remove(token);
				return false;
			}

			/** Otherwise, add the token and return TRUE. */
			that.add(token);
			return true;
		};

		return that;
	};

	return _DOMTokenList;
})();

(function() {
	// source:https://github.com/Financial-Times/polyfill-service/blob/master/polyfills/DOMTokenList
	if (
		!(
			'DOMTokenList' in this &&
			(function(x) {
				return 'classList' in x ? !x.classList.toggle('x', false) && !x.className : true;
			})(document.createElement('x'))
		)
	) {
		(function(global) {
			var nativeImpl = 'DOMTokenList' in global && global.DOMTokenList;

			if (
				!nativeImpl ||
				(!!document.createElementNS &&
					!!document.createElementNS('http://www.w3.org/2000/svg', 'svg') &&
					!(
						document.createElementNS('http://www.w3.org/2000/svg', 'svg').classList instanceof
						DOMTokenList
					))
			) {
				global.DOMTokenList = _DOMTokenList;
			}

			// Add second argument to native DOMTokenList.toggle() if necessary
			(function() {
				var e = document.createElement('span');
				if (!('classList' in e)) return;
				e.classList.toggle('x', false);
				if (!e.classList.contains('x')) return;
				e.classList.constructor.prototype.toggle = function toggle(token /*, force*/) {
					var force = arguments[1];
					if (force === undefined) {
						var add = !this.contains(token);
						this[add ? 'add' : 'remove'](token);
						return add;
					}
					force = !!force;
					this[force ? 'add' : 'remove'](token);
					return force;
				};
			})();

			// Add multiple arguments to native DOMTokenList.add() if necessary
			(function() {
				var e = document.createElement('span');
				if (!('classList' in e)) return;
				e.classList.add('a', 'b');
				if (e.classList.contains('b')) return;
				var native = e.classList.constructor.prototype.add;
				e.classList.constructor.prototype.add = function() {
					var args = arguments;
					var l = arguments.length;
					for (var i = 0; i < l; i++) {
						native.call(this, args[i]);
					}
				};
			})();

			// Add multiple arguments to native DOMTokenList.remove() if necessary
			(function() {
				var e = document.createElement('span');
				if (!('classList' in e)) return;
				e.classList.add('a');
				e.classList.add('b');
				e.classList.remove('a', 'b');
				if (!e.classList.contains('b')) return;
				var native = e.classList.constructor.prototype.remove;
				e.classList.constructor.prototype.remove = function() {
					var args = arguments;
					var l = arguments.length;
					for (var i = 0; i < l; i++) {
						native.call(this, args[i]);
					}
				};
			})();
		})(this);
	}

	// source:https://github.com/Financial-Times/polyfill-service/tree/master/polyfills/DOMTokenList/prototype/@@iterator
	if (
		'Symbol' in this &&
		'iterator' in this.Symbol &&
		!!document.createElement('div').classList[Symbol.iterator]
	) {
		DOMTokenList.prototype[Symbol.iterator] = function() {
			return new ArrayIterator(this);
		};
	}

	// source:https://github.com/Financial-Times/polyfill-service/blob/master/polyfills/Element/prototype/classList
	if (
		!(
			'document' in this &&
			'classList' in document.documentElement &&
			'Element' in this &&
			'classList' in Element.prototype &&
			(function() {
				var e = document.createElement('span');
				e.classList.add('a', 'b');
				return e.classList.contains('b');
			})()
		)
	) {
		/*
  Copyright (c) 2016, John Gardner
  Permission to use, copy, modify, and/or distribute this software for any purpose with or without fee is hereby granted, provided that the above copyright notice and this permission notice appear in all copies.
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
  */
		(function(global) {
			var dpSupport = true;
			var defineGetter = function defineGetter(object, name, fn, configurable) {
				if (Object.defineProperty)
					Object.defineProperty(object, name, {
						configurable: false === dpSupport ? true : !!configurable,
						get: fn
					});
				else object.__defineGetter__(name, fn);
			};
			/** Ensure the browser allows Object.defineProperty to be used on native JavaScript objects. */
			try {
				defineGetter({}, 'support');
			} catch (e) {
				dpSupport = false;
			}
			/** Polyfills a property with a DOMTokenList */
			var addProp = function addProp(o, name, attr) {
				defineGetter(
					o.prototype,
					name,
					function() {
						var tokenList;

						var THIS = this,
							/** Prevent this from firing twice for some reason. What the hell, IE. */
							gibberishProperty = '__defineGetter__' + 'DEFINE_PROPERTY' + name;
						if (THIS[gibberishProperty]) return tokenList;
						THIS[gibberishProperty] = true;

						/**
						 * IE8 can't define properties on native JavaScript objects, so we'll use a dumb hack instead.
						 *
						 * What this is doing is creating a dummy element ("reflection") inside a detached phantom node ("mirror")
						 * that serves as the target of Object.defineProperty instead. While we could simply use the subject HTML
						 * element instead, this would conflict with element types which use indexed properties (such as forms and
						 * select lists).
						 */
						if (false === dpSupport) {
							var visage;
							var mirror = addProp.mirror || document.createElement('div');
							var reflections = mirror.childNodes;
							var l = reflections.length;

							for (var i = 0; i < l; ++i) {
								if (reflections[i]._R === THIS) {
									visage = reflections[i];
									break;
								}
							} /** Couldn't find an element's reflection inside the mirror. Materialise one. */
							visage || (visage = mirror.appendChild(document.createElement('div')));

							tokenList = DOMTokenList.call(visage, THIS, attr);
						} else tokenList = new DOMTokenList(THIS, attr);

						defineGetter(THIS, name, function() {
							return tokenList;
						});
						delete THIS[gibberishProperty];

						return tokenList;
					},
					true
				);
			};

			addProp(global.Element, 'classList', 'className');
			addProp(global.HTMLElement, 'classList', 'className');
			addProp(global.HTMLLinkElement, 'relList', 'rel');
			addProp(global.HTMLAnchorElement, 'relList', 'rel');
			addProp(global.HTMLAreaElement, 'relList', 'rel');
		})(this);
	}

	// source:https://github.com/Financial-Times/polyfill-service/blob/master/polyfills/Element/prototype/cloneNode
	if (
		!(
			'document' in this &&
			'cloneNode' in document.documentElement &&
			(function() {
				var div = document.createElement('div'),
					test = document.createElement('input');
				test.type = 'radio';
				test.checked = true;
				div.appendChild(test);
				var result = test.cloneNode(false),
					result2;
				try {
					result2 = div.cloneNode();
				} catch (e) {}
				return !!result.checked && (!result2 || result2.childNodes.length === 0);
			})()
		)
	) {
		Element.prototype.cloneNode = (function(nativeFunc, undefined) {
			return function(deep) {
				if (deep === undefined) {
					deep = false;
				}
				var clone = nativeFunc.call(this, deep);

				if ('checked' in this) clone.checked = this.checked;

				return clone;
			};
		})(Element.prototype.cloneNode);
	}

	// source:https://github.com/Financial-Times/polyfill-service/blob/master/polyfills/Element/prototype/dataset
	if (
		!(function() {
			if (!document.documentElement.dataset) {
				return false;
			}
			var el = document.createElement('div');
			el.setAttribute('data-a-b', 'c');
			return el.dataset && el.dataset.aB == 'c';
		})()
	) {
		Object.defineProperty(Element.prototype, 'dataset', {
			get: function get() {
				var element = this;
				var attributes = this.attributes;
				var map = {};

				for (var i = 0; i < attributes.length; i++) {
					var attribute = attributes[i];

					if (attribute && attribute.name && /^data-\w[\w\-]*$/.test(attribute.name)) {
						var name = attribute.name;
						var value = attribute.value;

						var propName = name.substr(5).replace(/-./g, function(prop) {
							return prop.charAt(1).toUpperCase();
						});

						Object.defineProperty(map, propName, {
							enumerable: this.enumerable,
							get: function() {
								return this.value;
							}.bind({ value: value || '' }),
							set: function setter(name, value) {
								if (typeof value !== 'undefined') {
									this.setAttribute(name, value);
								} else {
									this.removeAttribute(name);
								}
							}.bind(element, name)
						});
					}
				}

				return map;
			}
		});
	}

	// source:https://github.com/Financial-Times/polyfill-service/blob/master/polyfills/Element/prototype/matches
	if (!('document' in this && 'matches' in document.documentElement)) {
		Element.prototype.matches =
			Element.prototype.webkitMatchesSelector ||
			Element.prototype.oMatchesSelector ||
			Element.prototype.msMatchesSelector ||
			Element.prototype.mozMatchesSelector ||
			function matches(selector) {
				var element = this;
				var elements = (element.document || element.ownerDocument).querySelectorAll(selector);
				var index = 0;

				while (elements[index] && elements[index] !== element) {
					++index;
				}

				return !!elements[index];
			};
	}

	// source:https://github.com/Financial-Times/polyfill-service/blob/master/polyfills/Element/prototype/closest
	if (!('document' in this && 'closest' in document.documentElement)) {
		Element.prototype.closest = function closest(selector) {
			var node = this;

			while (node) {
				if (node.matches(selector)) return node;
				else
					node =
						'SVGElement' in window && node instanceof SVGElement
							? node.parentNode
							: node.parentElement;
			}

			return null;
		};
	}
}.call(window));
